import React from "react";
import {
  Box,
  Typography,
  Paper,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Slider,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom"; // Import useNavigate

const categories = [
  { category: "Art" },
  { category: "Business Economics" },
  { category: "Computers" },
  { category: "Dentistry" },
  { category: "Education" },
  { category: "Engineering" },
  { category: "House & Home" },
  { category: "Law" },
  { category: "Life Sciences" },
  { category: "Mathematics" },
];

const languages = ["English", "Spanish", "French", "German", "Chinese", "Japanese"];

const bindingTypes = ["Paperback", "Hardcover", "E-book", "Audio Book"];

const marks = [
  { value: 0, label: "$0" },
  { value: 100, label: "$100" },
];

const FilterSidebar = ({ filters, onFilterChange, onResetFilters }) => {
  const navigate = useNavigate(); // Initialize useNavigate

  const handleCategoryFilterChange = (event) => {
    const { value, checked } = event.target;
    onFilterChange("category", value, checked);

    // Redirect to the category page
    if (checked) {
      navigate(`/${value.toLowerCase().replace(/ /g, "-")}`);
    }
  };

  const handlePriceRangeChange = (event, newValue) => {
    onFilterChange("priceRange", newValue);
  };

  const handleLanguageFilterChange = (event) => {
    const { value, checked } = event.target;
    onFilterChange("language", value, checked);
  };

  const handleBindingTypeFilterChange = (event) => {
    const { value, checked } = event.target;
    onFilterChange("bindingType", value, checked);
  };

  const handleResetFilters = () => {
    if (typeof onResetFilters === "function") {
      onResetFilters();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: 250,
        borderRight: "1px solid #ccc",
        backgroundColor:'#fff'
      }}
    >
      <Paper elevation={0} sx={{ p: 1, borderBottom: "2px solid #ccc", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" gutterBottom>
          Filters
        </Typography>
        <Button  size="small" onClick={handleResetFilters}>
          Clear all
        </Button>
      </Paper>

      {/* Category filter */}
      <FormControl component="fieldset" fullWidth sx={{ m:2 }}>
        <FormLabel sx={{ textAlign: "left" }}>Category</FormLabel>
        <FormGroup>
          {categories.map((category) => (
            <FormControlLabel
              key={category.category}
              control={
                <Checkbox
                  onChange={handleCategoryFilterChange}
                  value={category.category}
                />
              }
              label={category.category}
              checked={filters.category.includes(category.category)}
            />
          ))}
        </FormGroup>
      </FormControl>

      {/* Price range filter */}
      <FormControl component="fieldset"  sx={{ mb: 2, ml:2 , mr:2}}>
        <FormLabel sx={{ textAlign: "left" }} id="price-range-label">
          Price Range
        </FormLabel>
        <Slider
          value={filters.priceRange}
          onChange={handlePriceRangeChange}
          valueLabelDisplay="auto"
          aria-labelledby="price-range-label"
          marks={marks}
          min={0}
          max={100}
        />
      </FormControl>

      {/* Language filter */}
      <FormControl component="fieldset" fullWidth sx={{ mb: 2, ml:2 }}>
        <FormLabel sx={{ textAlign: "left" }}>Language</FormLabel>
        <FormGroup>
          {languages.map((language) => (
            <FormControlLabel
              key={language}
              control={
                <Checkbox
                  onChange={handleLanguageFilterChange}
                  value={language}
                />
              }
              label={language}
              checked={filters.language.includes(language)}
            />
          ))}
        </FormGroup>
      </FormControl>

      {/* Binding type filter */}
      <FormControl component="fieldset" fullWidth sx={{ mb: 2, ml:2 }}>
        <FormLabel sx={{ textAlign: "left" }} component="legend">
          Binding Type
        </FormLabel>
        <FormGroup>
          {bindingTypes.map((bindingType) => (
            <FormControlLabel
              key={bindingType}
              control={
                <Checkbox
                  onChange={handleBindingTypeFilterChange}
                  value={bindingType}
                />
              }
              label={bindingType}
              checked={filters.bindingType.includes(bindingType)}
            />
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  );
};

export default FilterSidebar;
